import { browserHistory } from 'react-router';

import {
  PAPERWORK,
  PAPERWORK_VISIT_DETAILS,
  PAPERWORK_COMPLETE_VISIT_DETAILS,
} from '../../constants/routes';

export function redirectToPaperworkVisitDetails(id) {
  browserHistory.replace(`${PAPERWORK}/${id}/${PAPERWORK_VISIT_DETAILS}`);
}

export function redirectToPaperworkCompletedVisitDetails(id) {
  browserHistory.replace(
    `${PAPERWORK}/${id}/${PAPERWORK_COMPLETE_VISIT_DETAILS}`,
  );
}



// WEBPACK FOOTER //
// ./src/utils/paperwork/redirect-utils.js